export default function(workscale) {
  // switch (workscale){
  //   case 0:
  //   return "#0099CCAA"
  //   case 1:
  //   return "#1FB1A4AA"
  //   case 2:
  //   return "#ffc820AA"
  //   case 3:
  //   return "#E85252AA"
  //   default:
  //   return "#CCCCCCE5"
  // }

  //prerendered alphas
  switch (workscale) {
    case 0:
      return "#5eb9dc";
    case 1:
      return "#6cc9c0";
    case 2:
      return "#fdd971";
    case 3:
      return "#ee8a8a";
    default:
      return "#d9d9d9";
  }
}
